import { render, staticRenderFns } from "./UserTaskList.vue?vue&type=template&id=b2e22ec6&"
import script from "./UserTaskList.vue?vue&type=script&lang=ts&"
export * from "./UserTaskList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports